import { FavoriteButtonWrapperContainer } from '@cian/favorites-assign-widget';
import { Button, Heart16, HeartStroke16, TooltipDesktop } from '@cian/ui-kit';
import * as React from 'react';

import { ControlWrapper } from '../../../../components/ControlWrapper';
import { OfferContext } from '../../../../context';
import { TOfferContextData } from '../../../../types/offer-card';

export function FavoritesControlContainer() {
  const {
    user: { isAuthenticated },
    offer,
    api: { onFavoritesChange },
  } = React.useContext(OfferContext) as TOfferContextData;

  const [isFavorite, setFavorite] = React.useState(Boolean(offer.isFavorite));

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onFavoritesChange(!isFavorite);
    setFavorite(!isFavorite);
  };

  const handleLogin = React.useCallback(() => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  }, []);

  const button = (
    <TooltipDesktop theme="black" placement="left" title={isFavorite ? 'В избранном' : 'Добавить в избранное'}>
      <Button
        data-mark="FavoritesControl"
        size="XS"
        theme="stroke_secondary"
        onClick={handleClick}
        beforeIcon={isFavorite ? <Heart16 color="error_100" /> : <HeartStroke16 />}
      />
    </TooltipDesktop>
  );

  if (offer.isCianPartner) {
    return null;
  }

  return (
    <ControlWrapper visible={isFavorite}>
      <FavoriteButtonWrapperContainer
        offerId={offer.cianId}
        placement="bottom-end"
        isAuthenticated={isAuthenticated}
        onWaitForLogin={handleLogin}
      >
        {button}
      </FavoriteButtonWrapperContainer>
    </ControlWrapper>
  );
}
